import type { FreeInterviewStateV1 } from '@/shared/api';

export function freePageStep(
	requested: string,
	state: Pick<FreeInterviewStateV1, 'step' | 'attemptId'>,
) {
	if (requested === 'report' && state.step === 'complete') return 'report';
	if (requested === 'session' && state.step === 'interview' && state.attemptId)
		return 'session';
	if (
		['onboarding', 'join', 'telegram'].includes(requested) &&
		state.step === 'interview' &&
		!state.attemptId
	)
		return 'join';
	return state.step === 'telegram' ? 'join' : state.step;
}

export function freeCourseDestination(
	state: Pick<
		FreeInterviewStateV1,
		'step' | 'telegramLinked' | 'courseId' | 'messengerProvider'
	>,
	skipJoin = false,
) {
	const ready =
		skipJoin && state.messengerProvider !== 'salebot'
			? state.step === 'telegram' || state.step === 'interview'
			: state.step === 'interview' && state.telegramLinked;
	return ready ? `/course/${encodeURIComponent(state.courseId)}` : null;
}

export function freePath(
	id: string,
	step: string,
	courseId?: string,
	source = 'direct',
	autoStart = false,
) {
	const query = new URLSearchParams({
		source: source === 'landing' ? 'landing' : 'direct',
	});
	if (courseId) query.set('courseId', courseId);
	if (autoStart && step === 'interview') query.set('autostart', '1');
	const suffix =
		step === 'interview' ? '' : `/${step === 'telegram' ? 'join' : step}`;
	return `/interviews/${encodeURIComponent(id)}${suffix}?${query}`;
}
export function freeEvent(
	reach: (goal: string, params: Record<string, string>) => void,
	event: string,
	context: Record<string, unknown>,
) {
	const params: Record<string, string> = {};
	for (const key of [
		'provider',
		'interviewId',
		'courseId',
		'step',
		'source',
		'action',
		'outcome',
		'field',
		'optionId',
		'language',
		'placement',
		'section',
		'target',
	])
		if (typeof context[key] === 'string') params[key] = context[key] as string;
	try {
		reach(`free_interview_${event}`, params);
	} catch {
		/* Analytics never blocks the interview. */
	}
}

export function freeAuthAttribution(target: string) {
	const course = target.match(/^\/course\/([^/?]+)\/about(?:\?|$)/);
	const interview = target.match(/^\/(?:free-interview|interviews)\/([^/?]+)/);
	if (!course && !interview) return null;
	const query = new URLSearchParams(target.split('?')[1]);
	return {
		courseId: course?.[1] ?? encodeURIComponent(query.get('courseId') ?? ''),
		interviewId: interview?.[1] ?? '',
		source: course || query.get('source') === 'landing' ? 'landing' : 'direct',
	};
}
